"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BloodyClawsAbilityHandler = exports.BloodyClawsActorAbilityFactory = exports.BloodyClawsAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const EffectType_1 = require("../../core/effects/EffectType");
const Random_1 = require("../../utils/Random");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class BloodyClawsAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.BloodyClaws;
        this.__typeName = "BloodyClaws";
    }
}
exports.BloodyClawsAbilityArgs = BloodyClawsAbilityArgs;
let BloodyClawsActorAbilityFactory = class BloodyClawsActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("BloodyClaws", "AllEnemies", 2);
    }
};
BloodyClawsActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("BloodyClaws")
], BloodyClawsActorAbilityFactory);
exports.BloodyClawsActorAbilityFactory = BloodyClawsActorAbilityFactory;
let BloodyClawsAbilityHandler = class BloodyClawsAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        let targetIds = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        const isBloodlust = container.hasEffectOfType(ability.invokerId, EffectType_1.EffectType.Bloodlust);
        if (isBloodlust) {
            targetIds = [
                ...targetIds,
                ...targetIds
            ];
        }
        sequence = sequence.pushSequence("parallel");
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            attackerId: ability.invokerId,
            targets: targetIds.map(targetId => {
                var _a;
                return ({
                    targetId,
                    damages: [
                        AbilityDamage_1.AbilityDamage.Power("Physical", 60),
                        AbilityDamage_1.AbilityDamage.Power("Death", 60),
                    ],
                    effects: [
                        {
                            targetId,
                            duration: Duration_1.Duration.Permanent,
                            effect: new core_1.SoulDrainEffectArgs("Power", 10),
                        },
                        {
                            targetId,
                            duration: Duration_1.Duration.Instant,
                            effect: new core_1.RemoveSpecificEffectEffectArgs((_a = (0, Random_1.randomElement)(container.getHelpfulEffects(targetId, false))) === null || _a === void 0 ? void 0 : _a.id)
                        }
                    ]
                });
            }),
            onHitOrMiss: (sequence, { targetId }, { hit }) => {
                sequence.push(new core_2.InstantVfxStepArgs(hit ? new LocationSelector_1.ActorVfxLocationSelector(targetId, isBloodlust ? "random" : "chest")
                    : LocationSelector_1.ActorVfxLocationSelector.Miss(targetId), "BloodyClaws"));
            }
        });
    }
};
BloodyClawsAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.BloodyClaws)
], BloodyClawsAbilityHandler);
exports.BloodyClawsAbilityHandler = BloodyClawsAbilityHandler;
